import { render, staticRenderFns } from "./CharityTermsModal.vue?vue&type=template&id=7f0a7c04&scoped=true&"
import script from "./CharityTermsModal.vue?vue&type=script&lang=js&"
export * from "./CharityTermsModal.vue?vue&type=script&lang=js&"
import style0 from "./CharityTermsModal.vue?vue&type=style&index=0&id=7f0a7c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a7c04",
  null
  
)

export default component.exports